import { forceBrowserDownload } from '../utils/download';

angular.module('app.directives').directive('lowLatencyPlayer', function ($timeout, $analytics) {
  'ngInject';

  return {
    restrict: 'E',
    scope: { broadcast: '=' },
    template: `
        <div>
          <div ng-show="no_op || !dismissed" style="position:absolute; z-index:1; top:50px; left:20px; right:20px; padding:10px 30px 10px 10px; border: 1px solid;" class="bg-warning text-warning text-center" style="border:1px solid;margin:45px 15px 15px 15px;padding:15px;">
            <button type="button" class="close" ng-click="dismissed = true" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            Low-Latency Preview requires Flash, which is no longer supported.<br>
            You can still view the preview in BoxCast Broadcaster on your iOS device or in VLC if it is installed on your computer.
            <ul class="list-inline" style="margin-top:10px">
              <li>
                <button type="button" ng-click="openVLC(broadcast)" class="btn btn-default">
                <img src="/img/icon-vlc.png" style="height:32px"> Open with VLC
                </button>
              </li>
              <li>•</li>
              <li>
                <a href="https://www.videolan.org/vlc/" target="_blank" class="subtle-link">Download VLC</a>
              </li>
              <li>•</li>
              <li>
                <a href="https://support.boxcast.com/en/articles/4235096-troubleshoot-remotely-using-low-latency-preview" target="_blank" class="subtle-link">Learn More</a>
              </li>
            </ul>
          </div>
          <div id="{{:: id}}" class="player"></div>
        </div>
      `,
    link(scope, element, attrs, ngModel) {
      scope.id = `player-${0 | (Math.random() * 1000000)}`;
      scope.no_op = false;
      scope.dismissed = false;

      let ctx = boxcast(`#${scope.id}`);
      scope.$watch(
        () => scope.broadcast && scope.broadcast.rtmp_preview_url,
        function (rtmp_preview_url) {
          if (rtmp_preview_url) {
            ctx.unload();
            ctx.loadLowLatency(rtmp_preview_url, {
              disableMetrics: true,
              debug: true,
              env: BOXCAST_JS_ENV,
              onLoadPlayer: (p) => {
                if (p.core.getCurrentPlayback().name == 'no_op') {
                  $analytics.eventTrack('playback-blocked', { category: 'low-latency-player' });
                  ctx.unload();
                  scope.$evalAsync(() => (scope.no_op = true));
                  if (canRequestPermission) {
                    // in case, when flash is not available, try to prompt user to enable it
                    requestFlashPermission();
                    // Chrome requires user's click in order to allow iframe embeding
                    $(window).one('click', requestFlashPermission);
                  }
                }
              },
            });
          } else {
            ctx.unload();
          }
        }
      );

      scope.openVLC = (broadcast) => {
        const vlcPlaylist = `<?xml version="1.0" encoding="UTF-8"?>
          <playlist xmlns="http://xspf.org/ns/0/" xmlns:vlc="http://www.videolan.org/vlc/playlist/ns/0/" version="1">
            <title>BoxCast Preview</title>
            <trackList>
              <track>
                <location>${broadcast.rtmp_preview_url}</location>
                <extension application="http://www.videolan.org/vlc/playlist/0">
                  <vlc:id>0</vlc:id>
                  <vlc:option>network-caching=1000</vlc:option>
                </extension>
              </track>
            </trackList>
            <extension application="http://www.videolan.org/vlc/playlist/0">
              <vlc:item tid="0"/>
            </extension>
          </playlist>
          `;
        forceBrowserDownload(
          'data:application/octet-stream;charset=utf-8,' + vlcPlaylist,
          'boxcast-playlist.xspf'
        );
      };

      scope.$on('$destroy', () => {
        if (ctx) ctx.unload();
      });

      $analytics.eventTrack('playback-requested', { category: 'low-latency-player' });
    },
  };
});

/**
 * Tries to show browser's promt for enabling flash
 *
 * Chrome starting from 56 version and Edge from 15 are disabling flash
 * by default. To promt user to enable flash, they suggest to send user to
 * flash player download page. Then this browser will catch such request
 * and show a promt to user:
 * https://www.chromium.org/flash-roadmap#TOC-Developer-Recommendations
 * In this method we are forcing such promt by navigating user to adobe
 * site in iframe, instead of top window
 */
function requestFlashPermission() {
  var iframe = document.createElement('iframe');
  iframe.src = 'https://get.adobe.com/flashplayer';
  iframe.sandbox = '';
  document.body.appendChild(iframe);
  document.body.removeChild(iframe);
}

var isNewEdge =
  navigator.userAgent.match(/Edg\//) || (navigator.userAgent.match(/Edge\/(\d+)/) || [])[1] > 14;
var isNewSafari = (navigator.userAgent.match(/OS X (\d+)/) || [])[1] > 9;
var isNewChrome =
  (navigator.userAgent.match(/Chrom(e|ium)\/(\d+)/) || [])[2] > 56 &&
  !/Mobile/i.test(navigator.userAgent);
var canRequestPermission = isNewEdge || isNewSafari || isNewChrome;



// WEBPACK FOOTER //
// ./app/directives/low-latency-player.js